export default __webpack_public_path__ + "static/media/fingureImage.d53aa1bd.png";